const STORE_NAME = 'appState';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        language: 'en',
        loading: false,
        sidebarCollapsed: false,
        api: {
            partner: null,
        },
    },
    mutations: {
        setLanguage(state, language) {
            state.language = language;
        },
        setApiPartner(state, partner) {
            state.api.partner = partner;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setSidebarCollapsed(state, value) {
            state.sidebarCollapsed = value;
        },
    },
    actions: {
        setLanguage({ commit }, language) {
            commit('setLanguage', language);
        },
        setApiPartner({ commit }, partner) {
            commit('setApiPartner', partner);
        },
        setLoading({ commit }, loading = true) {
            commit('setLoading', loading);
        },
        toggleSidebarCollapsed({ state, commit }) {
            commit('setSidebarCollapsed', !state.sidebarCollapsed);
        },
    },
    _persistent: {
        getDataToSave: (state) => {
            return {
                language: state[STORE_NAME].language,
            };
        },
        getDataToLoad: (data) => data,
    },
};
